import React, { useState, useEffect } from 'react';
import './toast.css';

const Toast = ({
    title,
    status
}) => {
    const [isVisible, setIsVisible] = useState(true);
    const [titleState, setTitle] = useState(title);
    const [statusState, setStatus] = useState(status);

    useEffect(() => {
        console.log(1);
        setIsVisible(true);
        // Полностью скрыть через 2.3 секунды (после завершения анимации)
        const hideTimer = setTimeout(() => {
            setIsVisible(false);
        }, 2300);

        // Очистка таймеров при размонтировании компонента
        return () => {

            clearTimeout(hideTimer);
        };
    }, [titleState]);




    if (!isVisible) {
        return null;
    }

    return (
        <div className={`toast-block ${statusState} `}>
            {titleState}
        </div>
    );
};

export default Toast;
